import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EmailService } from './__email/email.service';
import { map } from 'rxjs/operators';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfigService } from './___common/__config/config.service';

const VOYJALEAS_INFO_EMAIL = 'info@voyjaleas.com';

@Injectable({
  providedIn: 'root'
})
export class OmnibusService {

  emailForm;
  studentForm;
  loadedStudentInfo;
  omnibusContract;
  emailInfoSent = false;

  constructor(private http: HttpClient,private emailService: EmailService,private fb: FormBuilder,private configService: ConfigService) { }

  buildStudentForm(debug = false): FormGroup {
    return this.fb.group({
      name: ['', Validators.required],
      lastname1: [debug ? 'Develop' : null, Validators.required],
      lastname2: [debug ? 'Test' : null, Validators.required],
      birthDate: [debug ? '2025-04-16' : null, Validators.required],
      gender: [debug ? 'M' : null, Validators.required],
      passportNumber: [debug ? '1234' : null, Validators.required],
      address: [debug ? 'Extranjero' : null, Validators.required],
      country: [debug ? 'Costa Rica' : null, Validators.required],
      email: [debug ? 'sebasjb3@gmail.com' : null, [Validators.required, Validators.email]],
      phone: [debug ? '12345678' : null, Validators.required]
    });
  }

  buildSeguroForm(debug = false): FormGroup {
    return this.fb.group({
      mesInicio: [null,Validators.required],
      anioInicio: ['2025',Validators.required],
      duracionCurso: [9,Validators.required],
      university: ['EAE', Validators.required]
    });
  }


  getAdminEmail(){
    return this.emailService.getAdminEmail();
  }

  isEmailInfoSent(){
    return this.emailInfoSent;
  }

  createStudentRow(p_studentData){
    const createStudent$ = this.http.post(
      this.configService.getApiUrlRefactor('appBase')+'post/create.php?table=student',
      p_studentData
    );
    return createStudent$;
  }

  updateStudentInfo(p_studentUpdated,lastStudentInserted_id){
    const updateStudent$ = this.http.put(
      this.configService.getApiUrlRefactor('appBase')+'put/updateRow.php?table=student&id='+lastStudentInserted_id,
      p_studentUpdated
    );
    return updateStudent$;
  }

  // MISC - POST AND PUT OPS
  updateContractInfo(contract_Id,p_contractUpdated){
    const updateContract$ = this.http.put(
      this.configService.getApiUrlRefactor('appBase')+'put/updateRow.php?table=omnibusContract&id='+contract_Id,
      p_contractUpdated
    );
    return updateContract$;
  }

  calculateDates(startMonth, startYear, monthsDuration) {
    // Create the start date (1st of the startMonth and startYear)
    const startDate = new Date(startYear, startMonth - 1, 1);
  
    // Clone the date and add the duration
    const endDate = new Date(startDate);
    endDate.setMonth(endDate.getMonth() + monthsDuration);
  
    // Return both dates in ISO format (or you can return the Date objects if preferred)
    return {
      startDate: startDate.toISOString().split('T')[0],
      endDate: endDate.toISOString().split('T')[0]
    };
  }

  prepareEmailConfigObject(processCode,emailFormData,studentObj,studentInfo,omnibusContract){
    let emailConfig;
    switch(processCode){
      //STEP 0
      case 'client0':
        emailConfig = {
          template: 'requestInsuranceInfoLead',
          emailTo:  emailFormData.email,
          subject: 'Información seguro médico ASISA',
          from: VOYJALEAS_INFO_EMAIL,
          fromLabel: 'VoyJaleas App',
          mainButtonLink: this.configService.getApiUrlRefactor('domainWebapp')+'/#/sub-app/health-helper'
        }
        break;
      case 'admin0':
        emailConfig = {
          template: 'requestInsuranceInfoAdmin',
          emailTo: this.getAdminEmail(),
          subject: 'Robot: Lead seguro Medico',
          from: VOYJALEAS_INFO_EMAIL,
          fromLabel: 'Admin VoyJaleas App',
          mainButtonLink: this.configService.getApiUrlRefactor('domainDashboard')+'/#/om-dashboard',
          leadEmail: emailFormData.email
        }
        break;
      //STEP 3
      case 'client3':
        emailConfig = {
          template: 'docsReceivedStep3',
          emailTo: studentObj.email,
          subject: 'Seguro Medico: documentación recibida',
          from: VOYJALEAS_INFO_EMAIL,
          fromLabel: 'VoyJaleas App',
          tokenSeguro: omnibusContract.token,
          name: studentObj.name,
          lastname: studentObj.lastname1,
          startDate: omnibusContract.startDate,
          endDate: omnibusContract.endDate
        }
        break;
      case 'admin3':
        emailConfig = {
          template: 'clientUploadedDocs3',
          emailTo: this.getAdminEmail(),
          subject: 'Robot: Seguro Medico',
          from: VOYJALEAS_INFO_EMAIL,
          fromLabel: 'Admin VoyJaleas App',
          mainButtonLink: this.configService.getApiUrlRefactor('domainDashboard')+'/#/om-dashboard',
          name: studentObj.name,
          lastname: studentObj.lastname1
        }
        break;
    //STEP 6
    case 'client6':
      emailConfig = {
        template: 'docsReceivedStep6',
        emailTo: studentInfo.email,
        subject: 'Seguro Medico: documentación recibida',
        from: VOYJALEAS_INFO_EMAIL,
        fromLabel: 'VoyJaleas App',
        mainButtonLink: this.configService.getApiUrlRefactor('domainWebapp')+'/#/sub-app/health-helper/'+omnibusContract.token,
        name: studentInfo.name,
        lastname: studentInfo.lastname1
      }
      break;
    case 'admin6':
      emailConfig = {
        template: 'clientUploadedDocs6',
        emailTo: this.getAdminEmail(),
        subject: 'Robot: Seguro Medico',
        from: VOYJALEAS_INFO_EMAIL,
        fromLabel: 'Admin VoyJaleas App',
        mainButtonLink: this.configService.getApiUrlRefactor('domainDashboard')+'/#/om-dashboard',
        name: studentInfo.name,
        lastname: studentInfo.lastname1,
        contractId: omnibusContract.id
      }
      break;
    case 'admin8':
      emailConfig = {
        template: 'clientPaid',
        emailTo: this.getAdminEmail(),
        subject: 'Robot: Seguro Medico',
        from: VOYJALEAS_INFO_EMAIL,
        fromLabel: 'Admin VoyJaleas App',
        mainButtonLink: this.configService.getApiUrlRefactor('domainDashboard')+'/#/om-dashboard',
        name: studentInfo.name,
        lastname: studentInfo.lastname1
      }
      break;
    default:
        break;
    }
    return emailConfig;
  }

  sendOmnibusProcessEmail(processCode){
    let emailObj = this.prepareEmailConfigObject(processCode,this.emailForm,this.studentForm.value,this.loadedStudentInfo,this.omnibusContract);
    this.emailService.sendOmnibusProcessEmail(emailObj);
  }

  sendNotificationEmails(processStatus,emailForm,studentForm,studentInfo,omnibusContract){
    this.emailForm = emailForm;
    this.studentForm = studentForm;
    this.omnibusContract = omnibusContract;
    this.loadedStudentInfo = studentInfo;
    switch(processStatus){
      case 0:
        //Notify the client and the admin
        this.sendOmnibusProcessEmail('client0');
        this.sendOmnibusProcessEmail('admin0');
        this.emailInfoSent = true;
        break;
      //STEP 1
      case 1:
        break;
      case 3:
        //Notify the client and the admin
        this.sendOmnibusProcessEmail('client3');
        this.sendOmnibusProcessEmail('admin3');
        break;
      case 6:
        //Notify the client and the admin
        this.sendOmnibusProcessEmail('client6');
        this.sendOmnibusProcessEmail('admin6');
        break;
      case 8:
        //Notify the admin that payment was done
        this.sendOmnibusProcessEmail('admin8');
        break;
      default:
        break;
    }
  }

  getDocumentsToUpload(processStatus){
    let documentsToUpload = [];
    switch(processStatus){
      //STEP 1
      case 1:
        break;
      case 3:
        //Upload only this step docs
        documentsToUpload = [
          {
            file_id: 'passport',
            description: 'Fotocopia del pasaporte',
          },
          {
            file_id: 'cartaAceptacion',
            description: 'Carta de aceptación universidad',
          }
        ];
        break;
      case 6:
        //Upload only this step docs
        documentsToUpload = [
          {
            file_id: 'formularioRelleno',
            description: 'Formulario Solicitud Relleno',
          },
          {
            file_id: 'cuestionarioRelleno',
            description: 'Cuestionario ASISA Relleno',
          }
        ];
        break;
      default:
        break;
    }
    return documentsToUpload;
  }

  getStudentInfo(idStudent){
    return this.http.get<any>(this.configService.getApiUrl('appGet')+'?queryId=getStudentInfo&queryParam1='+idStudent)
      .pipe(map(data => this.getResponse(data)));
  }

  getResponse(d){
    return d;
  }
      
}
